import * as React from 'react';

import {Card} from 'shells/card/card';

import styles from './field-mapping.module.css';

export function FieldMappingPlaceholder() {
    return (
        <Card hasBorder={true} hasShadow={true}>
            <div className='pad-16 flex flex-dir-col gap-16'>
                <div className={styles.header}>Field mapping</div>
                <div className={styles['field-mapping-placeholder']}>Click any field to edit</div>
            </div>
        </Card>
    );
}
